import { render, staticRenderFns } from "./NewsAdd.vue?vue&type=template&id=0cb56b86&scoped=true"
import script from "./NewsAdd.vue?vue&type=script&lang=js"
export * from "./NewsAdd.vue?vue&type=script&lang=js"
import style0 from "./NewsAdd.vue?vue&type=style&index=0&id=0cb56b86&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb56b86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cb56b86')) {
      api.createRecord('0cb56b86', component.options)
    } else {
      api.reload('0cb56b86', component.options)
    }
    module.hot.accept("./NewsAdd.vue?vue&type=template&id=0cb56b86&scoped=true", function () {
      api.rerender('0cb56b86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/news-management/components/NewsAdd.vue"
export default component.exports